import React, { Component } from 'react';
import { Tooltip } from '@platform/base';

export default class TipsTitle extends Component {

    state = { showTips: false };
    hoverTimer = null;
    onTitleClick = () => {
        let { onTitleClick } = this.props;
        if (typeof onTitleClick === 'function') {onTitleClick();}
    }

    onMouseEnter = e => {
        if (e.target && e.target.scrollWidth > e.target.clientWidth) {
            if (!this.state.showTips) {
                this.hoverTimer = setTimeout(() => {
                    this.setState({ showTips: true });
                }, 500);
            }
        }
    }
    onMouseLeave = e => {
        if (this.hoverTimer) {clearTimeout(this.hoverTimer);}
        if (this.state.showTips) {this.setState({ showTips: false });}
    }
    render() {
        let { className = '', title, tagType = 'span' } = this.props;
        return <Tooltip
            inverse
            overlay={<div>{title}</div>}
            placement="top"
            visible={this.state.showTips}
        >
            {tagType === 'span' ? <span className={className}
                onClick={this.onTitleClick}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                {title}
            </span> : <div className={className}
                onClick={this.onTitleClick}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                {title}
            </div>}
        </Tooltip>;
    }
}